import type { TraceComponent } from "./types/TraceComponent";
import TraceLevel from "./TraceLevel";
import type { TraceErrorObject } from "owa-analytics-types";
import { getTraceRetentionWindowInMS } from "./getTraceRetentionWindowInMS";

export type TraceCache = {
    timeStamp: string;
    message: string;
    traceLevel: string;
    component: TraceComponent | undefined;
    errorDetails?: string;
};

let traceCache: TraceCache[] = [];
let isIssueBeingReproed: boolean = false;
let traceDuringReproCache: TraceCache[] = [];

export function pushTraceToCache(message: string, traceLevel: TraceLevel, component: TraceComponent | undefined, errorDetails?: TraceErrorObject): void {
    const traceInfo: TraceCache = {
        timeStamp: new Date().toISOString(),
        message,
        traceLevel: TraceLevel[traceLevel],
        component,
        errorDetails: errorDetails ? JSON.stringify(errorDetails) : "",
    };
    
    traceCache.push(traceInfo);
}

export function flushExpiredTraces(): void {
    traceCache = traceCache.filter(entry => new Date().getTime() - new Date(entry.timeStamp).getTime() <=
        getTraceRetentionWindowInMS());
}

export function getTraceCache(): TraceCache[] {
    return traceCache;
}

export function pushTraceDuringReproToCache(message: string, traceLevel: TraceLevel, component: TraceComponent | undefined, errorDetails?: TraceErrorObject): void {
    if (isIssueBeingReproed) {
        const traceInfo: TraceCache = {
            timeStamp: new Date().toISOString(),
            message,
            traceLevel: TraceLevel[traceLevel],
            component,
            errorDetails: errorDetails ? JSON.stringify(errorDetails) : "",
        };
        
        traceDuringReproCache.push(traceInfo);
    }
}

export function startTracingDuringRepro(): Promise<void> {
    isIssueBeingReproed = true;
    return Promise.resolve();
}

export function stopTracingDuringRepro(): Promise<void> {
    isIssueBeingReproed = false;
    return Promise.resolve();
}

export function getTraceDuringReproCache(): TraceCache[] {
    return traceDuringReproCache;
}

export function resetTraceDuringReproCache(): void {
    traceDuringReproCache = [];
}
